// extracted by mini-css-extract-plugin
export default {"tab":"Tab-module_tab__Bg30r","selected":"Tab-module_selected__mxJNg","disabled":"Tab-module_disabled__Su43A","content":"Tab-module_content__DhMvT"};